const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(num);
};

export default formatNumber;
